import { Alert, Card, Col, Collapse, Progress, Row, Statistic, Tag, Tooltip } from "antd"
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { authRequest } from "../../../../common/request/authRequest";
import { RingProgress } from "@ant-design/charts";
import MathUtils from "../../../../common/utils/MathUtils";
import { ApiOutlined, CheckCircleFilled, CheckSquareFilled, CloseSquareFilled, EnvironmentOutlined, GlobalOutlined, HeartOutlined, InfoCircleOutlined, QrcodeOutlined, UserOutlined, WarningFilled, WarningOutlined, YoutubeFilled } from "@ant-design/icons";
import rocketIcon from '../../../../assets/rocketIcon.png';import { useAuth } from "../../../../store/AuthContext/AuthContext";
import { ROLES, useBasePlan, useIsAuthorized, useModuleActive } from "../../common/roles/Roles";
import moment from "moment";
import { PageTitle } from "../../common/PageTitle";

export const Plan = () => {

    const { projectGroup, profile } = useAuth();
    const [project, setProject] = useState<any>(null);    
    const [projectMetrics, setProjectMetrics] = useState<any>(null);    

    const isAuthorized = useIsAuthorized();
    const isModuleActive = useModuleActive();    
    const getMainPlain = useBasePlan();    
    
	useEffect(() => {
        
        authRequest(`${process.env.REACT_APP_API}/projects/` + projectGroup.project + '/credits',
            { method: 'GET' }
            )
            .then((data) => {                
                setProject(data.project);
                setProjectMetrics(data.projectMetrics);
            })            
        }, []); 	

        const MODULES: any = {

            COMPETITORS: {name: "Competidores", video:'https://www.youtube.com/watch?v=gRitZT6_bnM', icon: <EnvironmentOutlined/>, active: isModuleActive('COMPETITORS'), credits: true, description: "Permite medir tu posicionamiento local en comparación a tus competidores", features:["Rank traking de keywords locales", "Programación de mapas", "Comparativa de reseñas"]},
            WEB_SYNC: {name: "Web", video:'https://www.youtube.com/watch?v=EplmHzcPP7I', icon: <GlobalOutlined/>, active: isModuleActive('WEB_SYNC'), credits: false, description: "Permite enriquecer tu web con información de los perfiles de Google", features:["Widget de últimas reseñas", "Widget de datos de contacto"]},
            QR_ANALYTICS: {name: "QR Analytics", icon: <QrcodeOutlined/>, active: isModuleActive('QR_ANALYTICS'), credits: false, description: "Crea QRs para tus empleados y monitoriza el número de reseñas que obtienen", features:["Generar QR para monitorizar #escaneos", "Panel de reseñas por empleado"]},
            SENTIMENT_ANALYSIS: {name: "Análisis de Sentimiento", active: isModuleActive('SENTIMENT_ANALYSIS'), icon: <HeartOutlined/>, credits: false, description: "Análisis de sentimiento y semántico de tus reseñas", features:["Feedback semántico con embeddings", "Etiquetado de reseñas", "Análisis de sentimiento"]},
            API: {name: "Conexión a API", icon: <ApiOutlined/>, active: isModuleActive('API'), credits: false, description: "Para soluciones a medida que requieren acceder programáticamente a los datos", features:["Obtener datos de rendimiento", "Obtener datos de reseñas"]},
            USERS: {name: "Usuarios", video:'https://www.youtube.com/watch?v=nk1GI_lm_mU', icon: <UserOutlined/>, active: isModuleActive('USERS'), credits: false, description: "Permite crear usuarios, incluso si no tienen cuenta de Google Business Profile", features:["Invitar a usuarios", "Restringir permisos"]},
            // Preguntas
            // Marca Blanca
            // Módulo de etiquetas
        }

    const contractedLocations = project?.contractNumberOfLocations ?? 0;
    const activeLocations = projectMetrics?.numberOfLocations ?? 0;
    const overQuota = activeLocations > contractedLocations;

    const creditsPerMonth = project?.creditsPlan?.creditsPerMonth ?? 0;
    const creditsAvailable = project?.creditsPlan?.credits ?? 0;
    const creditsUsedPercent = creditsPerMonth > 0
        ? Math.round(100 - (100 * creditsAvailable / creditsPerMonth))
        : 0;
    const currentMonthLabel = moment().format('MMMM').charAt(0).toUpperCase() + moment().format('MMMM').slice(1);

    const kpiCardBody = {
        backgroundColor: 'white',
        borderRadius: 16,
        minHeight: 170,
        border: 'solid .5px #c5cdd6',
        padding: '16px 18px',
    };

    return (
        <>
        <Card className='main-card-content'>
                        
            <PageTitle
                title='Plan Contratado'
                pageInfo='Consulta el plan base, los locales contratados y los módulos disponibles o activos en tu proyecto.'
            />
                        
			<Row gutter={16} style={{ marginTop: 24, marginBottom: 20 }}>
                <Col xs={24} md={7}>
                    <Card bodyStyle={kpiCardBody}>
                        <div style={{ fontSize: 13, fontWeight: 600, color: 'LightSlateGray', marginBottom: 16 }}>
                            Plan Base
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                            <img src={rocketIcon} style={{ height: 52, borderRadius: 12 }} alt="" />
                            <div style={{
                                fontSize: 18,
                                fontWeight: 700,
                                border: 'solid 2px purple',
                                color: 'purple',
                                padding: '6px 12px',
                                borderRadius: 12,
                            }}>
                                {ROLES[getMainPlain()]}
                            </div>
                        </div>
                    </Card>
                </Col>

                <Col xs={24} md={8}>
                    <Card bodyStyle={kpiCardBody}>
                        <div style={{ fontSize: 13, fontWeight: 600, color: 'LightSlateGray', marginBottom: 10 }}>
                            Locales
                        </div>

                        <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 4 }}>
                            <span style={{ fontSize: 28, fontWeight: 700, color: overQuota ? 'crimson' : '#1a202c', lineHeight: 1 }}>
                                {activeLocations}
                            </span>
                            <span style={{ fontSize: 16, color: '#94a3b8', fontWeight: 600 }}>/</span>
                            <span style={{ fontSize: 22, fontWeight: 700, color: '#1a202c', lineHeight: 1 }}>
                                {contractedLocations}
                            </span>
                        </div>
                        <div style={{ fontSize: 12, color: 'LightSlateGray', marginBottom: overQuota ? 12 : 0 }}>
                            Activos en plataforma / contratados
                        </div>

                        {overQuota ? (
                            <div style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: 8,
                                padding: '8px 10px',
                                background: 'LavenderBlush',
                                border: '1px solid pink',
                                borderRadius: 8,
                                color: 'MediumVioletRed',
                                fontSize: 12,
                                lineHeight: 1.35,
                            }}>
                                <WarningOutlined style={{ marginTop: 1, flexShrink: 0 }} />
                                <span>
                                    Hay más locales activos ({activeLocations}) que los contratados ({contractedLocations}). 
                                </span>
                            </div>
                        ) : null}
                    </Card>
                </Col>

                <Col xs={24} md={9}>
                    <Card bodyStyle={{ ...kpiCardBody, backgroundColor: '#FFFEF7' }}>
                        <div style={{ fontSize: 13, fontWeight: 600, color: 'LightSlateGray', marginBottom: 10 }}>
                            Créditos · {currentMonthLabel}
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                            <div>
                                <div style={{ fontSize: 28, fontWeight: 700, color: 'purple', lineHeight: 1 }}>
                                    {creditsAvailable}
                                </div>
                                <div style={{ fontSize: 12, color: 'LightSlateGray', marginTop: 4 }}>
                                    disponibles
                                </div>
                                <div style={{ fontSize: 12, color: '#1a202c', marginTop: 8 }}>
                                    <b>{creditsPerMonth}</b>
                                    <span style={{ color: 'LightSlateGray' }}> / mes del plan</span>
                                </div>
                            </div>
                            <div style={{ textAlign: 'center' }}>
                                <Progress
                                    width={78}
                                    type="dashboard"
                                    strokeWidth={12}
                                    strokeColor="purple"
                                    trailColor="#dde3ea"
                                    percent={creditsUsedPercent}
                                />
                                <div style={{ fontSize: 11, color: 'LightSlateGray', marginTop: -4 }}>
                                    consumidos
                                </div>
                            </div>
                        </div>
                    </Card>
                </Col>
            </Row>

                    {/*project?.creditsPlan?.name*/}
                    
                    {/*!isAuthorized(['ROLE_ADMIN', 'ROLE_CLIENT']) && 
                        <h3 style={{color:'MediumVioletRed', background:'LavenderBlush', padding:'5px', marginBottom:'15px', border:'1px solid pink'}}>
                            <InfoCircleOutlined/> Tu plan no incluye gestión masiva de fichas
                        </h3>
    */}
                    {!isModuleActive('AUTOMATED_REVIEWS') && 
                        <h3 style={{color:'MediumVioletRed', background:'LavenderBlush', padding:'5px', marginBottom:'15px', border:'1px solid pink'}}>
                            <InfoCircleOutlined/> Tu plan no incluye automatización de reseñas 
                        </h3>
                    }
                    {!isModuleActive('SCHEDULED_POSTS') && 
                        <h3 style={{color:'MediumVioletRed', background:'LavenderBlush', padding:'5px', border:'1px solid pink'}}>
                            <InfoCircleOutlined/> Tu plan no incluye programación de posts 
                        </h3>
                    }                    
                    
                    <h1 className='title-card'>Módulos</h1>
                    <br/>
                    {Object.keys(MODULES).map((moduleName: string) => (
                      <Card
                        key={moduleName}
                        bodyStyle={{
                          backgroundColor: MODULES[moduleName].active ? 'white' : 'transparent',
                          borderRadius: 20,
                          margin: '10px 0',
                          border: 'solid .5px silver',
                          padding: '12px 20px',
                        }}
                        style={{ border: 'transparent' }}
                      >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16 }}>
                            <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
                                <span style={{ fontSize: 20, lineHeight: 1 }}>
                                  {MODULES[moduleName].active
                                    ? <CheckSquareFilled style={{ color: 'purple' }} />
                                    : <CloseSquareFilled style={{ color: 'slategrey' }} />}
                                </span>
                                <div style={{ marginLeft: 24, minWidth: 0 }}>
                                    <div style={{
                                      color: MODULES[moduleName].active ? 'purple' : 'slategrey',
                                      marginBottom: 4,
                                      fontSize: 17,
                                      fontWeight: 700,
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 10,
                                      flexWrap: 'wrap',
                                    }}>
                                        {MODULES[moduleName].icon} {MODULES[moduleName].name}
                                        {MODULES[moduleName].credits && (
                                          <Tag style={{ margin: 0, borderRadius: 15, color: 'purple', border: 'solid 1px purple' }} color="white">
                                            Consume créditos
                                          </Tag>
                                        )}
                                    </div>
                                    <div>
                                        {MODULES[moduleName].description}
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                            {MODULES[moduleName].video && <a href={MODULES[moduleName].video} target='blank'> <YoutubeFilled style={{ fontSize: 25, color: 'red' }} /></a>}
                                <div style={{ minWidth: 230 }}>
                                    <Collapse ghost>
                                        <Collapse.Panel key="features" header={'Ver Funcionalidades'}>
                                        <ul style={{ marginBottom: 0 }}>
                                            {
                                                MODULES[moduleName].features.map((feature: string) => (
                                                    <li key={feature}>{feature}</li>
                                                    ))
                                            }
                                        </ul>
                                        </Collapse.Panel>
                                    </Collapse>
                                </div>
                            </div>
                        </div>
                  </Card>
                    ))}
        </Card>    
        </>
    )
}
    
const configProgress: any = {
	height: 75,
	width: 75,
	autoFit: false,
	color: ['#5B8FF9', '#E8EDF3'],
};



